module.exports = __webpack_public_path__ + "img/图片-1.7bb7a182.png";